import { render, staticRenderFns } from "./SaveAdIcon.vue?vue&type=template&id=2024ef1b&scoped=true"
import script from "./SaveAdIcon.vue?vue&type=script&lang=js"
export * from "./SaveAdIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024ef1b",
  null
  
)

export default component.exports